import { z } from 'zod'

import { REPOSITORY_SYSTEM_OPTIONS } from '#app/routes/mocra+/_form+/components/repositories/constants.ts'

export const RepositoryEntrySchema = z.object({
	system: z.enum(
		REPOSITORY_SYSTEM_OPTIONS.map((option) => option.value) as [
			(typeof REPOSITORY_SYSTEM_OPTIONS)[number]['value'],
			...string[],
		],
	),
	location: z
		.string({
			required_error: 'Enter the folder path or location.',
		})
		.min(1, 'Enter the folder path or location.'),
})

export type RepositoryEntry = z.infer<typeof RepositoryEntrySchema>
